module.exports = __webpack_public_path__ + "static/media/prepaid_a06.89db1408.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/prepaid_a06.png
// module id = 734
// module chunks = 21